'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var RescriptReactRouter = require("@rescript/react/lib/js/src/RescriptReactRouter.js");
var Error$PvpcontrollerWeb = require("./Error.js");
var Theme$PvpcontrollerWeb = require("../Theme.js");
var Search$PvpcontrollerWeb = require("./Search.js");
var LoadMore$PvpcontrollerWeb = require("./LoadMore.js");
var Debugging$PvpcontrollerWeb = require("../Debugging.js");
var WeaponCardGrid$PvpcontrollerWeb = require("./WeaponCardGrid.js");
var ProjectileService$PvpcontrollerWeb = require("../services/ProjectileService.js");
var ProjectileCardGrid$PvpcontrollerWeb = require("./ProjectileCardGrid.js");

function initialProjectilesPopulate(setState, terms) {
  React.useEffect((function () {
          return ProjectileService$PvpcontrollerWeb.getProjectiles(0, 104, (function (projectiles) {
                        if (projectiles.TAG === /* Ok */0) {
                          var projectiles$1 = projectiles._0;
                          return Curry._1(setState, (function (previousState) {
                                        var match = terms.length;
                                        if (previousState === 0 && match === 0) {
                                          return {
                                                  TAG: /* Projectiles */0,
                                                  _0: projectiles$1
                                                };
                                        } else {
                                          return previousState;
                                        }
                                      }));
                        }
                        var err = projectiles._0;
                        if (err.RE_EXN_ID === "Match_failure") {
                          var match = err._1;
                          Debugging$PvpcontrollerWeb.messageWithData("Projectiles-PvpcontrollerWeb" + (":getProjectiles Could not destructure projectile type. Failed at " + match[0] + ":L" + String(match[1]) + "_C" + String(match[2])), {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        } else {
                          Debugging$PvpcontrollerWeb.messageWithData("Projectiles-PvpcontrollerWeb:getProjectiles Could not get projectiles.", {
                                tags: (function (prim) {
                                    return {};
                                  }),
                                extra: err
                              });
                        }
                        return Curry._1(setState, (function (_previousState) {
                                      return /* LoadingFailed */1;
                                    }));
                      }));
        }), []);
  
}

function getProjectilesLoaded(state) {
  if (typeof state === "number") {
    return 0;
  }
  switch (state.TAG | 0) {
    case /* Projectiles */0 :
    case /* AllProjectiles */1 :
        return state._0.length;
    case /* Searching */2 :
        return state._0.nonSearchState._0.length;
    case /* SearchResults */3 :
        return state._0.nonSearchState._0.length;
    
  }
}

function content(state, setState) {
  if (typeof state === "number") {
    if (state !== /* Loading */0) {
      return React.createElement(Error$PvpcontrollerWeb.make, Error$PvpcontrollerWeb.makeProps(undefined, undefined));
    }
    
  } else {
    switch (state.TAG | 0) {
      case /* Projectiles */0 :
          return [
                  React.createElement(ProjectileCardGrid$PvpcontrollerWeb.make, ProjectileCardGrid$PvpcontrollerWeb.makeProps(state._0, "grid", undefined)),
                  React.createElement(LoadMore$PvpcontrollerWeb.make, LoadMore$PvpcontrollerWeb.makeProps((function (param) {
                              if (param.TAG !== /* Ok */0) {
                                return Curry._1(setState, (function (_previousState) {
                                              return /* LoadingFailed */1;
                                            }));
                              }
                              var projectiles = param._0;
                              return Curry._1(setState, (function (previousState) {
                                            if (typeof previousState === "number") {
                                              return previousState;
                                            }
                                            switch (previousState.TAG | 0) {
                                              case /* Projectiles */0 :
                                                  var allProjectiles = previousState._0;
                                                  if (projectiles.length < 104) {
                                                    return {
                                                            TAG: /* AllProjectiles */1,
                                                            _0: allProjectiles.concat(projectiles)
                                                          };
                                                  } else {
                                                    return {
                                                            TAG: /* Projectiles */0,
                                                            _0: allProjectiles.concat(projectiles)
                                                          };
                                                  }
                                              case /* AllProjectiles */1 :
                                                  return previousState;
                                              case /* Searching */2 :
                                                  var searching = previousState._0;
                                                  var nonSearchState = searching.nonSearchState;
                                                  var tmp;
                                                  tmp = nonSearchState.TAG === /* Projectiles */0 ? ({
                                                        TAG: /* Projectiles */0,
                                                        _0: nonSearchState._0.concat(projectiles)
                                                      }) : ({
                                                        TAG: /* AllProjectiles */1,
                                                        _0: nonSearchState._0.concat(projectiles)
                                                      });
                                                  return {
                                                          TAG: /* Searching */2,
                                                          _0: {
                                                            nonSearchState: tmp,
                                                            terms: searching.terms
                                                          }
                                                        };
                                              case /* SearchResults */3 :
                                                  var results = previousState._0;
                                                  var nonSearchState$1 = results.nonSearchState;
                                                  var tmp$1;
                                                  tmp$1 = nonSearchState$1.TAG === /* Projectiles */0 ? ({
                                                        TAG: /* Projectiles */0,
                                                        _0: nonSearchState$1._0.concat(projectiles)
                                                      }) : ({
                                                        TAG: /* AllProjectiles */1,
                                                        _0: nonSearchState$1._0.concat(projectiles)
                                                      });
                                                  return {
                                                          TAG: /* SearchResults */3,
                                                          _0: {
                                                            terms: results.terms,
                                                            results: results.results,
                                                            nonSearchState: tmp$1
                                                          }
                                                        };
                                              
                                            }
                                          }));
                            }), (function (param) {
                              
                            }), ProjectileService$PvpcontrollerWeb.getProjectiles, getProjectilesLoaded(state), 104, Theme$PvpcontrollerWeb.loadMore, "loadmore", undefined))
                ];
      case /* AllProjectiles */1 :
          return React.createElement(ProjectileCardGrid$PvpcontrollerWeb.make, ProjectileCardGrid$PvpcontrollerWeb.makeProps(state._0, "grid", undefined));
      case /* Searching */2 :
          break;
      case /* SearchResults */3 :
          return React.createElement(ProjectileCardGrid$PvpcontrollerWeb.make, ProjectileCardGrid$PvpcontrollerWeb.makeProps(state._0.results, "grid", undefined));
      
    }
  }
  return React.createElement(WeaponCardGrid$PvpcontrollerWeb.Fake.make, WeaponCardGrid$PvpcontrollerWeb.Fake.makeProps(104, undefined, undefined));
}

function Projectiles(Props) {
  var match = React.useState(function () {
        return /* Loading */0;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = RescriptReactRouter.useUrl(undefined, undefined).path;
  var terms;
  if (match$1 && match$1.hd === "projectiles") {
    var match$2 = match$1.tl;
    if (match$2 && match$2.hd === "search") {
      var match$3 = match$2.tl;
      terms = match$3 ? match$3.hd : "";
    } else {
      terms = "";
    }
  } else {
    terms = "";
  }
  initialProjectilesPopulate(setState, terms);
  var title;
  if (typeof state === "number") {
    title = "All Projectiles";
  } else {
    switch (state.TAG | 0) {
      case /* Searching */2 :
          title = "Searching for \"" + state._0.terms + "\"";
          break;
      case /* SearchResults */3 :
          title = "Search results for \"" + state._0.terms + "\"";
          break;
      default:
        title = "All Projectiles";
    }
  }
  return React.createElement("div", undefined, React.createElement("div", {
                  className: Theme$PvpcontrollerWeb.top
                }, React.createElement("h2", {
                      className: Theme$PvpcontrollerWeb.title
                    }, title), React.createElement(Search$PvpcontrollerWeb.make, Search$PvpcontrollerWeb.makeProps(terms, "/projectiles", (function (param, param$1) {
                            if (param$1.TAG !== /* Ok */0) {
                              return ;
                            }
                            var results = param$1._0;
                            return Curry._1(setState, (function (previousState) {
                                          if (typeof previousState === "number") {
                                            if (previousState === /* Loading */0) {
                                              return {
                                                      TAG: /* SearchResults */3,
                                                      _0: {
                                                        terms: param,
                                                        results: results,
                                                        nonSearchState: {
                                                          TAG: /* Projectiles */0,
                                                          _0: []
                                                        }
                                                      }
                                                    };
                                            } else {
                                              return {
                                                      TAG: /* SearchResults */3,
                                                      _0: {
                                                        terms: param,
                                                        results: results,
                                                        nonSearchState: {
                                                          TAG: /* Projectiles */0,
                                                          _0: []
                                                        }
                                                      }
                                                    };
                                            }
                                          }
                                          switch (previousState.TAG | 0) {
                                            case /* Projectiles */0 :
                                                return {
                                                        TAG: /* SearchResults */3,
                                                        _0: {
                                                          terms: param,
                                                          results: results,
                                                          nonSearchState: {
                                                            TAG: /* Projectiles */0,
                                                            _0: previousState._0
                                                          }
                                                        }
                                                      };
                                            case /* AllProjectiles */1 :
                                                return {
                                                        TAG: /* SearchResults */3,
                                                        _0: {
                                                          terms: param,
                                                          results: results,
                                                          nonSearchState: {
                                                            TAG: /* AllProjectiles */1,
                                                            _0: previousState._0
                                                          }
                                                        }
                                                      };
                                            case /* Searching */2 :
                                                return {
                                                        TAG: /* SearchResults */3,
                                                        _0: {
                                                          terms: param,
                                                          results: results,
                                                          nonSearchState: previousState._0.nonSearchState
                                                        }
                                                      };
                                            case /* SearchResults */3 :
                                                return {
                                                        TAG: /* SearchResults */3,
                                                        _0: {
                                                          terms: param,
                                                          results: results,
                                                          nonSearchState: previousState._0.nonSearchState
                                                        }
                                                      };
                                            
                                          }
                                        }));
                          }), (function (param) {
                            return Curry._1(setState, (function (previousState) {
                                          if (typeof previousState === "number") {
                                            if (previousState === /* Loading */0) {
                                              return {
                                                      TAG: /* Searching */2,
                                                      _0: {
                                                        nonSearchState: {
                                                          TAG: /* Projectiles */0,
                                                          _0: []
                                                        },
                                                        terms: param
                                                      }
                                                    };
                                            } else {
                                              return {
                                                      TAG: /* Searching */2,
                                                      _0: {
                                                        nonSearchState: {
                                                          TAG: /* Projectiles */0,
                                                          _0: []
                                                        },
                                                        terms: param
                                                      }
                                                    };
                                            }
                                          }
                                          switch (previousState.TAG | 0) {
                                            case /* Projectiles */0 :
                                                return {
                                                        TAG: /* Searching */2,
                                                        _0: {
                                                          nonSearchState: {
                                                            TAG: /* Projectiles */0,
                                                            _0: previousState._0
                                                          },
                                                          terms: param
                                                        }
                                                      };
                                            case /* AllProjectiles */1 :
                                                return {
                                                        TAG: /* Searching */2,
                                                        _0: {
                                                          nonSearchState: {
                                                            TAG: /* AllProjectiles */1,
                                                            _0: previousState._0
                                                          },
                                                          terms: param
                                                        }
                                                      };
                                            case /* Searching */2 :
                                                return {
                                                        TAG: /* Searching */2,
                                                        _0: {
                                                          nonSearchState: previousState._0.nonSearchState,
                                                          terms: param
                                                        }
                                                      };
                                            case /* SearchResults */3 :
                                                return {
                                                        TAG: /* Searching */2,
                                                        _0: {
                                                          nonSearchState: previousState._0.nonSearchState,
                                                          terms: param
                                                        }
                                                      };
                                            
                                          }
                                        }));
                          }), (function (param) {
                            return Curry._1(setState, (function (previousState) {
                                          var nonSearchState;
                                          if (typeof previousState === "number") {
                                            return previousState;
                                          }
                                          switch (previousState.TAG | 0) {
                                            case /* Projectiles */0 :
                                                return previousState;
                                            case /* Searching */2 :
                                                nonSearchState = previousState._0.nonSearchState;
                                                break;
                                            case /* SearchResults */3 :
                                                nonSearchState = previousState._0.nonSearchState;
                                                break;
                                            default:
                                              return previousState;
                                          }
                                          if (nonSearchState.TAG === /* Projectiles */0) {
                                            return {
                                                    TAG: /* Projectiles */0,
                                                    _0: nonSearchState._0
                                                  };
                                          } else {
                                            return {
                                                    TAG: /* AllProjectiles */1,
                                                    _0: nonSearchState._0
                                                  };
                                          }
                                        }));
                          }), ProjectileService$PvpcontrollerWeb.searchProjectiles, undefined, undefined))), content(state, setState));
}

function makeProps(prim0, prim1) {
  var tmp = {};
  if (prim0 !== undefined) {
    tmp.key = prim0;
  }
  return tmp;
}

var make = Projectiles;

exports.makeProps = makeProps;
exports.make = make;
/* react Not a pure module */
